<template>
  <section class="container home-business"
    style="padding-right: 0">
    <div class="nav-head-info" style="padding-right: 15px">
      <p class="nav-head-title">{{navdata.navigationTitleEn}}</p>
      <p class="sort-line"></p>
      <p class="nav-head-text">{{navdata.navigationTitle}}</p>
      <router-link class="more-button"
                  :to="{
                    name: 'content',
                    query: {
                      primaryKey: navdata.primaryKey,
                    }
                  }">
        <p style="margin-bottom: 0">MORE</p> <span>></span>
      </router-link>
    </div>
    <section class="home-business-main row">
      <section class="module-item col-md-3"
                v-for="(item,index) in navList" :key="index"
                style="padding-right: 15px;">
        <router-link class="module-main"
                    :to="{
                      name: 'content',
                      query: {
                        primaryKey: item.navigationParent,
                        childNavKey: item.primaryKey,
                      }
                    }">
          <el-image :src="item.navigationImgUrl" lazy class="module-bg"></el-image>
          <section class="module-text-bg"></section>
          <div class="module-text">{{item.navigationTitle}}</div>
        </router-link>
      </section>
    </section>
  </section>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import { getNavList } from '../api/index'
import utils from '@/common/js/utils'
export default {
  props: ['navdata'],

  data () {
    return {
      navList:[]
    }
  },
  computed: {
    ...mapGetters({
      navInfo: 'getNavInfo'
    })
  },
  watch: {
    'navInfo.primaryKey' (val) {
      this.getNavList()
    }
  },
  methods: {
    async getNavList () {

      var res = await getNavList({navigationParent: this.navdata.primaryKey})
      this.navList = res.data || []
    }
  },
  mounted(){
    this.getNavList()
  },
}
</script>

<style lang="scss">
.home-business-main {
  display: flex;
  flex-wrap: wrap;
  /*justify-content: space-between;*/
  width: 100%;
  .col-md-3 {
    padding-left: 0;
  }
  .nav-head-info {
    .nav-head-title {
      font-size: 36px;
      margin-top: 50px;
    }

    .sort-line {
      margin-top: 30px;
      width: 50px;
      height: 1px;
      background: #B1CECC;
    }

    .nav-head-text {
      margin-top: 25px;
      font-size: 24px;
    }

    .nav-head-desc {
      margin-top: 35px;
      font-size: 16px;
      color: #757575;
      line-height: 24px;
      height: 148px;
      overflow: hidden;
    }
  }
  .module-item {
    /*width: 415px;*/
    height: 275px;
    margin: 15px 0;

    .module-main {
      width: 100%;
      height: 100%;
      position: relative;
      display: block;

      .module-bg {
        width: 100%;
        height: 100%;
      }

      .module-text-bg {
        position: absolute;
        bottom: 0;
        width: 100%;
        height: 47px;
        background: #B1CECC;
        opacity: 0.9;
      }
      .module-text {
        position: absolute;
        bottom: 0;
        width: 100%;
        height: 47px;
        font-size: 15px;
        color: #fff;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 0 15px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        margin: 0;
      }
    }

  }
}


@media screen and (max-width: 768px) {
  .home-business-main .col-md-3 {
    width: calc(50vw - 14px);
    overflow: hidden;
  }
}
</style>
